/**
 * OBD-1017: returns the header field keys in the order of the applied grid preference.
 *
 * The record grid rebuilds its `columns` prop whenever the rows or their list values load, and MUI
 * DataGrid rebuilds the column order from that array each time the prop changes. Sorting the keys
 * here keeps the preference's order across those rebuilds instead of falling back to the record
 * type's field order. Keys the preference does not mention keep their original relative order,
 * after the ones it does.
 *
 * @param keys {string[]} header field keys, in the record type's field order
 * @param orderedFields {string[] | undefined} column order of the applied preference
 */
export const orderByPreference = (keys: string[], orderedFields?: string[]): string[] => {
    if (!orderedFields?.length) return keys;
    const position = new Map(orderedFields.map((field, index) => [field, index]));
    return keys
        .map((key, index) => ({ key, index, rank: position.get(key) ?? orderedFields.length + index }))
        .sort((a, b) => a.rank - b.rank)
        .map(({ key }) => key);
};
